// eslint-disable-next-line import/no-internal-modules
import 'mapbox-gl/dist/mapbox-gl.css'

import { CircularProgress } from '@mui/material'
import { FlexGrowRow } from '@xylabs/sdk-react'
import { Quadkey } from '@xyo-network/sdk-xyoworld-js'
// eslint-disable-next-line no-restricted-imports
import mapboxgl from 'mapbox-gl'
import { useContext, useEffect, useRef } from 'react'

import { AppSettingsContext } from '../../Contexts'
import { XyoWorldMapStyle } from '../../lib'

interface GeoJsonMapProps {
  mapStyle?: XyoWorldMapStyle
  quadkey?: Quadkey
  ready?: boolean
  updateGeoJson?: (map: mapboxgl.Map) => void
  zoom?: number
}

// eslint-disable-next-line import/no-named-as-default-member
mapboxgl.accessToken = 'pk.eyJ1IjoicGFvbGFiYXRpeiIsImEiOiJjazdsM3pmNmswM293M2VtbnphNjF3YjI5In0.xYVfJRVJSRCJRBTBF6wRUA'

const GeoJsonMap: React.FC<GeoJsonMapProps> = (props) => {
  const { quadkey, mapStyle, updateGeoJson, ready = true } = props

  const center = quadkey?.geoJson()?.center()

  const defaultMapStyle = useContext(AppSettingsContext).mapStyle

  const mapContainerRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    if (ready) {
      const bounds = quadkey?.toBoundingBox()
      // eslint-disable-next-line import/no-named-as-default-member
      const map = new mapboxgl.Map({
        bounds,
        center,
        container: mapContainerRef.current ?? '',
        style: `mapbox://styles/${mapStyle ?? defaultMapStyle ?? XyoWorldMapStyle.Streets}`,
        zoom: quadkey?.zoom() ?? 2,
      })
      map.on('styledata', () => {
        console.log('Style Data')
        updateGeoJson?.(map)
      })
      map.on('zoomend', () => {
        console.log('Zoom End')
        updateGeoJson?.(map)
      })
      return () => map.remove()
    }
  }, [mapStyle, updateGeoJson, quadkey, center, defaultMapStyle, ready])

  return <div ref={(el) => (mapContainerRef.current = el)} style={{ bottom: 0, left: 0, position: 'absolute', right: 0, top: 0 }} />
}

interface GeoJsonMapBoxProps extends GeoJsonMapProps {
  height?: number
  width?: number
}

const GeoJsonMapBox: React.FC<GeoJsonMapBoxProps> = (props) => {
  const { height, width, ...mapProps } = props
  return (
    <FlexGrowRow position="relative" height={height} width={width}>
      {props.ready ? <GeoJsonMap {...mapProps} /> : <CircularProgress />}
    </FlexGrowRow>
  )
}

export { GeoJsonMap, GeoJsonMapBox }
